import { render, staticRenderFns } from "./AdviserSettingsBusinessCardInfo.vue?vue&type=template&id=dd0cdc46&scoped=true&"
import script from "./AdviserSettingsBusinessCardInfo.vue?vue&type=script&lang=js&"
export * from "./AdviserSettingsBusinessCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdviserSettingsBusinessCardInfo.vue?vue&type=style&index=0&id=dd0cdc46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0cdc46",
  null
  
)

export default component.exports